import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader, Loading, Empty } from "@/components/common/Common";
import { useScope } from "@/context/ScopeContext";
import { api } from "@/lib/api";
import { brl, day } from "@/lib/format";

export const CAMP_STATUS = {
  draft: ["Rascunho", "bg-slate-500/10 text-slate-600 dark:text-slate-300"], reviewed: ["Revisada", "bg-indigo-500/10 text-indigo-600 dark:text-indigo-300"],
  publishing: ["Publicando", "bg-amber-500/10 text-amber-600"], published: ["Publicada no Google Ads", "bg-emerald-500/10 text-emerald-600 dark:text-emerald-300"],
  publish_error: ["Erro ao publicar", "bg-rose-500/10 text-rose-600"],
};
export const CampStatus = ({ s }) => <span data-testid="campaign-status-badge" className={`text-[11px] font-mono px-2 py-1 rounded-full ${CAMP_STATUS[s]?.[1]}`}>{CAMP_STATUS[s]?.[0] || s}</span>;

export default function Campaigns() {
  const { clientId } = useScope();
  const [items, setItems] = useState(null);
  const [filter, setFilter] = useState("all");
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/campaigns", { params: clientId ? { client_id: clientId } : {} }).then((r) => setItems(r.data)); }, [clientId]);
  const F = { all: () => true, active: (c) => c.status === "published" && c.publish?.enabled, paused: (c) => c.status === "published" && !c.publish?.enabled, drafts: (c) => ["draft", "reviewed"].includes(c.status), problems: (c) => c.status === "publish_error" };
  const shown = (items || []).filter(F[filter]).filter((c) => c.name.toLowerCase().includes(q.toLowerCase()));
  return (
    <div>
      <PageHeader eyebrow="Campanhas" title="Suas campanhas" desc="Rascunhos criados com IA e campanhas publicadas pela plataforma."
        actions={<Button asChild data-testid="new-campaign-button"><Link to="/app/campaigns/new"><Plus className="h-4 w-4 mr-1" />Criar campanha</Link></Button>} />
      {!items ? <Loading /> : !items.length ? (
        <Empty title="Você ainda não possui campanhas." desc="Crie sua primeira campanha com IA." action={<Button asChild><Link to="/app/campaigns/new" data-testid="create-first-campaign">Criar primeira campanha</Link></Button>} />
      ) : (
        <>
        <div className="flex flex-wrap gap-2 mb-4">{[["all", "Todas"], ["active", "Ativas"], ["paused", "Pausadas"], ["drafts", "Rascunhos"], ["problems", "Problemas"]].map(([k, l]) => <button key={k} onClick={() => setFilter(k)} data-testid={`campaign-filter-${k}`} className={`h-8 px-3 rounded-full border text-sm ${filter === k ? "bg-accent text-accent-foreground border-primary/40 font-medium" : "text-muted-foreground"}`}>{l}</button>)}
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Pesquisar campanha" data-testid="campaign-search" className="h-8 px-3 rounded-lg border bg-card text-sm sm:ml-auto w-full sm:w-64" /></div>
        {!shown.length && <p className="text-sm text-muted-foreground py-6">Nenhuma campanha neste filtro.</p>}
        <div className="surface divide-y">
          {shown.map((c) => (
            <Link key={c.id} to={`/app/campaigns/${c.id}`} data-testid="campaign-row" className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-6 p-5 hover:bg-secondary/50 transition-colors">
              <div className="flex-1 min-w-0"><p className="font-medium truncate">{c.name}</p><p className="text-xs text-muted-foreground mt-0.5">{c.groups} grupos · {c.keywords} palavras-chave · {c.locations.join(", ")}</p></div>
              <span className="text-sm font-mono">{brl(c.daily_budget)}/dia</span>
              {c.score != null && <span className="text-xs font-mono text-muted-foreground">Estrutura {c.score}/100</span>}
              <CampStatus s={c.status} />
              <span className="text-xs text-muted-foreground">Atualizada {day(c.updated_at || c.created_at)}</span>
            </Link>
          ))}
        </div>
        </>
      )}
    </div>
  );
}
